import {IDataState} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';
import {createReducer} from 'store/config/creators';
import {TAction} from 'store/config/types';

import {MetadataActions} from './metadata-constants';
import {
    TFormDraftMetadataPayload,
    TMetadataResetPayload,
    TMetadataSetAllPayload,
    TMetadataSetPayload,
    IMetadataState,
} from './metadata-types';

const initialState: IMetadataState = {};

export const metadataReducer = createReducer(initialState, {
    [MetadataActions.SET_ALL_METADATA]: (state: IMetadataState, {payload}: TAction<TMetadataSetAllPayload>) => {
        const metadata = (() => {
            const data = {} as any;
            payload.metadata.forEach(entry => {
                const {name, viewType = 'default'} = entry;
                if (name) {
                    if (!data[name]) data[name] = {};
                    data[name][viewType] = entry;
                }
            });
            return data;
        })();
        return {...state, ...metadata};
    },
    [MetadataActions.SET_METADATA]: (
        state: IMetadataState,
        {payload}: TAction<TMetadataSetPayload>,
    ) => ({
        ...state,
        [payload.entityName]: {
            ...state[payload.entityName],
            [payload.entityType]: {
                ...payload.metadata,
            },
        },
    }),
    [MetadataActions.RESET_METADATA]: (
        state: IDataState,
        {payload}: TAction<TMetadataResetPayload>,
    ) => ({
        ...state,
        [payload.entityName]: {
            ...(state[payload.entityName] || {}),
            loading: payload.loading,
            [payload.entityType]: undefined,
        },
    }),
    [MetadataActions.SET_FORM_DRAFT_METADATA]: (
        state: IMetadataState,
        {payload}: TAction<TFormDraftMetadataPayload>,
    ) => ({
        ...state,
        [payload.entityName]: {
            ...state[payload.entityName],
            [EEntityType.FORM]: {
                ...state[payload.entityName]?.[EEntityType.FORM],
                isDraft: payload.isDraft,
            },
        },
    }),
});
